import { track, EventTypes } from '@mc/track-event'

// Hero
export const HERO_LOCATION = 'hero'

export const trackWatchTrailerClick = ({ slug }: { slug: string }) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'Watch Trailer',
    category: 'class-navigation',
    class: slug,
    location: HERO_LOCATION,
    page_category: 'class',
    page_path: window.location.pathname,
  })
}

// Course overview – "In your first week" section
const COURSE_OVERVIEW_LOCATION = 'In your first week'

export const trackCourseOverviewViewed = () =>
  track(`${COURSE_OVERVIEW_LOCATION} Viewed`)

// Skills you'll learn – "What you’ll learn" section
const SKILLS_YOU_LEARN_LOCATION = 'What you’ll learn'

export const trackSkillsYoullLearnViewed = () =>
  track(`${SKILLS_YOU_LEARN_LOCATION} Viewed`)

export const trackSampleClicked = ({
  slug,
  contentGemTitle,
}: {
  slug: string
  contentGemTitle: string
}) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'Sample',
    location: SKILLS_YOU_LEARN_LOCATION,
    class: slug,
    content_gem_title: contentGemTitle,
  })

export const trackMobileContentGemClicked = ({
  slug,
  contentGemTitle,
  link,
}: {
  slug: string
  contentGemTitle: string
  link: string
}) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'click',
    location: SKILLS_YOU_LEARN_LOCATION,
    class: slug,
    content_gem_title: contentGemTitle,
    link,
  })

// Instructor overview section
export const INSTRUCTOR_OVERVIEW_LOCATION = 'Instructor Overview'

export const trackInstructorOverviewViewed = () =>
  track(`${INSTRUCTOR_OVERVIEW_LOCATION} Viewed`)

// Timeline – "Over the next few months" section
const OVER_THE_NEXT_FEW_MONTHS_LOCATION = 'Over the next few months'

export const trackOverTheNextFewMonthsViewed = () =>
  track(`${OVER_THE_NEXT_FEW_MONTHS_LOCATION} Viewed`)

export const trackOutcomeClicked = ({
  slug,
  outcomeTitle,
}: {
  slug: string
  outcomeTitle: string
}) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'Trailer',
    location: OVER_THE_NEXT_FEW_MONTHS_LOCATION,
    class: slug,
    outcome_title: outcomeTitle,
  })

// Timeline – "Down the line" section
const DOWN_THE_LINE_LOCATION = 'Down the line'

export const trackDownTheLineViewed = () =>
  track(`${DOWN_THE_LINE_LOCATION} Viewed`)

// Value props - "Each class builds towards who you want to become" section
const VALUE_PROPS_LOCATION = 'Each class builds towards who you want to become'

export const trackValuePropsViewed = () =>
  track(`${VALUE_PROPS_LOCATION} Viewed`)

// "More reasons to join" section
const MORE_REASONS_TO_JOIN_LOCATION = 'More reasons to join'

export const trackMoreReasonsToJoinViewed = () =>
  track(`${MORE_REASONS_TO_JOIN_LOCATION} Viewed`)

// "Join millions who are growing with us" section
const TESTIMONIALS_LOCATION = 'Join millions who are growing with us'

export const trackTestimonialsViewed = () =>
  track(`${TESTIMONIALS_LOCATION} Viewed`)

// "Where will Masterclass take you" section
export const WHERE_WILL_MC_TAKE_YOU_LOCATION = 'Where will Masterclass take you'

export const trackWhereWillMCTakeYouViewed = () =>
  track(`${WHERE_WILL_MC_TAKE_YOU_LOCATION} Viewed`)
